export const messages = {
  en: {
    itemOutManage: {
      search: {
        title: 'Search Conditions',
        applyOrderId: 'Please enter order number',
        applyUserName: 'Please enter applicant name',
        resName: 'Please enter item name',
        startTime: 'Please select start time',
        endTime: 'Please select end time'
      },
      list: {
        title: 'Item Outbound Management',
        apply: 'Apply for Outbound'
      },
      table: {
        applyOrderId: 'Order Number',
        resourceNames: 'Item',
        userName: 'Applicant',
        createUserName: 'Operator',
        createTime: 'Application Time',
        stateName: 'Status',
        warehousingWay: 'Outbound Method',
        directOut: 'Direct Outbound',
        auditOut: 'Audit Outbound',
        flowChart: 'Flow Chart',
        cancelApply: 'Cancel Application',
        operation: 'Operation'
      }
    },
    deleteItemOut: {
      title: 'Confirm Operation',
      confirmText: 'Are you sure to cancel the outbound application?',
      deleteSuccess: 'Cancel outbound application successfully',
      cancelText: 'Cancel',
    }
  },
  zh: {
    itemOutManage: {
      search: {
        title: '查询条件',
        applyOrderId: '请输入单号',
        applyUserName: '请填写申请人姓名',
        resName: '请填写物品名称',
        startTime: '请选择开始时间',
        endTime: '请选择结束时间'
      },
      list: {
        title: '物品领用管理',
        apply: '领用申请'
      },
      table: {
        applyOrderId: '单号',
        resourceNames: '物品',
        userName: '申请人',
        createUserName: '操作人',
        createTime: '申请时间',
        stateName: '状态',
        warehousingWay: '领用方式',
        directOut: '直接出库',
        auditOut: '审核出库',
        flowChart: '流程图',
        cancelApply: '取消领用',
        operation: '操作'
      }
    },
    deleteItemOut: {
      title: '确认操作',
      confirmText: '确定取消领用吗?',
      deleteSuccess: '取消领用成功',
      cancelText: '点错了',
    }
  },
  'zh-TW': {
    itemOutManage: {
      search: {
        title: '查詢條件',
        applyOrderId: '請輸入單號',
        applyUserName: '請填寫申請人姓名',
        resName: '請填寫物品名稱',
        startTime: '請選擇開始時間',
        endTime: '請選擇結束時間'
      },
      list: {
        title: '物品領用管理',
        apply: '領用申請'
      },
      table: {
        applyOrderId: '單號',
        resourceNames: '物品',
        userName: '申請人',
        createUserName: '操作人',
        createTime: '申請時間',
        stateName: '狀態',
        warehousingWay: '領用方式',
        directOut: '直接出庫',
        auditOut: '審核出庫',
        flowChart: '流程圖',
        cancelApply: '取消領用',
        operation: '操作'
      }
    },
    deleteItemOut: {
      title: '確認操作',
      confirmText: '確定取消領用嗎?',
      deleteSuccess: '取消領用成功',
      cancelText: '點錯了',
    }
  }
}
